import '@fontsource-variable/manrope';
import {createRoot} from 'react-dom/client';
import App from './App';
import {prepare} from './security/keycloak';
import {loadThemeConfig} from './theme/themeConfig';
import {initUncaughtErrorListener} from './util/errorhandling/uncaughtErrorListener';
import {unregisterServiceWorkers} from './util/serviceWorker';

initUncaughtErrorListener();
unregisterServiceWorkers();

async function start() {
  const theme = await loadThemeConfig();
  document.title = theme.title;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme.themeColor);
  await prepare(theme.clientId);
  createRoot(document.getElementById('root')!).render(<App/>);
}

start().catch((error: unknown) => {
  console.error(error);
  alert('Etwas ist schief gelaufen!');
  alert(error);
});
